import { FloatButton } from "antd";
import { useTranslation } from "react-i18next";

import {
  EyeOutlined,
  EyeInvisibleOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import RobotGroupCardItem from "features/robot-teleop/components/robot-cards/robot-group-item";
import { useUserData } from "shared/contexts/UserDataProviderNew";
import { selectAllRobots } from "shared/reducer/userdata/selectors";
import RobotConnectionCardItem from "features/robot-teleop/components/robot-cards/robot-connection-item";
import { useState } from "react";
import RobotCardItem from "features/robot-teleop/components/robot-cards/robot-card-item";

const RobotCard = (props) => {
  const { t } = useTranslation();

  const { robotListLoading, robots, robotClientGroups, 
          isEnableOnlySelectedOrgRobots, setEnableOnlySelectedOrgRobots, 
          rolesInSelectedOrg, hasRoleInSelectedOrg, selectedOrg 
        } = useUserData();

  // const robots = userDataState.robotList;
  const robotGroups = robotClientGroups;
  // const { page, per_page, total, byId, allIds } = robots;
  // const robotsList = allIds?.map((id) => id) || [];


  const isPending = robotListLoading;

  const shutdownRobotClick = props.shutdownRobotClick;

  const restartRobotClick = props.restartRobotClick;
  const settingRobotClick = props.settingRobotClick;

  const showDeveloperLink = props.ShowDeveloperLink;

  const [showOfflineRobots, setShowOfflineRobots] = useState(
    props?.ShowOfflineRobots,
  );

  const [showConnections, setShowConnections] = useState(
    props?.ShowConnections || false,
  );

  return (
    <div className="table-responsive">
      {/* <h2>Dashboard</h2> */}

      <FloatButton.Group>
        {showConnections && (
          <FloatButton
            icon={<FolderOpenOutlined />}
            onClick={() => setShowConnections(false)}
            tooltip={<div>{t("dashboard.groupByRobot")}</div>}
            // type="primary"
          />
        )}
        {!showConnections && (
          <FloatButton
            icon={<FolderOpenOutlined />}
            onClick={() => setShowConnections(true)}
            tooltip={<div>{t("dashboard.showAll")}</div>}
            type="primary"
          />
        )}

        {!showOfflineRobots && (
          <FloatButton
            icon={<EyeInvisibleOutlined />}
            onClick={() => setShowOfflineRobots(true)}
            tooltip={<div>{t("dashboard.showOfflineRobots")}</div>}
            type="primary"
          />
        )}

        {showOfflineRobots && (
          <FloatButton
            icon={<EyeOutlined />}
            onClick={() => setShowOfflineRobots(false)}
            tooltip={<div>{t("dashboard.hideOfflineRobots")}</div>}
            // type="primary"
          />
        )}
      </FloatButton.Group>
      <div className="album py-5 bg-light">
        <div className="container">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-md-4 g-4">
            {robots.allIds
              .sort((a, b) => {
                const statusA = robotGroups[a]?.status === "online" ? 0 : 1;
                const statusB = robotGroups[b]?.status === "online" ? 0 : 1;
                if (statusA !== statusB) {
                  return statusA - statusB;
                }
                return a.localeCompare(b);
              })
              .map((robot_id) => {
                return (
                  robot_id &&
                  (robotGroups[robot_id]?.status === "online" ||
                    showOfflineRobots) && (
                    // <div key={robot_id + "_1"}> {robot_id} </div>
                    <RobotCardItem
                      {...props}
                      key={robot_id}
                      RobotClientGroup={robotGroups[robot_id]}
                      RobotInfo={robots.byId[robot_id]}
                      ShowConnections={showConnections}
                      Roles = {rolesInSelectedOrg}
                    ></RobotCardItem>
                  )
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RobotCard;
